import Schemas from './Schemas'
import Profiler from './Profiler/Profiler'
import RoleAnalysis from './RoleAnalysis/RoleAnalysis'
import ErrorReport from './ErrorReport'
import UsageReport from './UsageReport/UsageReport'
import RebuildSchemaTable from './RebuildSchemaTable'
import ExecuteSQL from './ExecuteSQL/ExecuteSQL'

export default function ToolsRoute({ match, location }) {
  console.log('ToolsRoute rendered', match, location)

  let procedure = null
  if (match) {
    if (match && match.params.procedure) {
      procedure = match.params.procedure
      console.log('procedure: ', procedure)
      switch (procedure) {
        case 'schemas':
          return <Schemas />
        case 'executeSQL':
          return <ExecuteSQL />
        case 'profiler':
          return <Profiler />
        case 'roleManager':
          return <RoleAnalysis />
        case 'errorReport':
          return <ErrorReport />
        case 'usageReport':
          return <UsageReport />
        case 'rebuildSchemaTable':
          return <RebuildSchemaTable />
        default:
      }
    }
  }
  return (
    <h3 style={{ marginTop: '20px', textAlign: 'center' }}>
      The tools route for this procedure has not yet been implemented: {procedure}
    </h3>
  )
}
